/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const handleError = async (ctx, data, _action, _params, mutation) => {
  if (mutation) await ctx.context.commit(mutation, data.message)
}
